
import React from 'react';
import { ExistingPatientDataModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { ExistingPatientDataModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new ExistingPatientDataModalViewStore(rootStore, componentProps), 'existingPatientDataModalViewStore')
@observer
class ExistingPatientDataModal extends React.Component {
    render() {
        return <ExistingPatientDataModalTemplate {...this.props} />
    }
}

export default ExistingPatientDataModal;
